// storage 相关操作
const postfix = '_DEADTIME'

export default new class Storage {
  setLocalData (key, value, time) {
    let storage = window.localStorage
    let seconds = parseInt(time)

    storage.setItem(key, value)
    if (seconds > 0) {
      let timestamp = Date.parse(new Date())
      timestamp = timestamp / 1000 + seconds
      storage.setItem(key + postfix, timestamp + '')
    } else {
      storage.removeItem(key + postfix)
    }
  }

  getLocalData (key, def) {
    let storage = window.localStorage
    let deadtime = parseInt(storage.getItem(key + postfix))
    if (deadtime) {
      if (parseInt(deadtime) < Date.parse(new Date()) / 1000) {
        console.log(key + '过期')
        if (def) {
          return def
        } else {
          return
        }
      }
    }
    let res = storage.getItem(key)
    if (res) {
      return res
    } else {
      return def
    }
  }

  removeLocalData (key) {
    let storage = window.localStorage
    storage.removeItem(key)
    storage.removeItem(key + postfix)
  }

  clearLocalData () {
    let storage = window.localStorage
    storage.clear()
  }
} ()



// WEBPACK FOOTER //
// ./src/utils/storage.js